import { LayoutComponent } from "@jelly/lesson";

import ka01 from "./ka-01/ka-01";
import ka1 from "./ka-1/ka-1";
import ka3 from "./ka-3/ka-3";
import ka4 from "./ka-4/ka-4";
import ka5 from "./ka-5/ka-5";
import ka6 from "./ka-6/ka-6";
import ka7 from "./ka-7/ka-7";
import ka8 from "./ka-8/ka-8";
import ka9 from "./ka-9/ka-9";
import ka10 from "./ka-10/ka-10";

const component: LayoutComponent = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 2,
      rows: 1,
      colsSize: [20, 1],
      components: [
        [
          {
            variant: "layout",
            data: {
              type: "slidersToggle",
              options: {
                controlsPosition: "bottom",
                theme: "primary",
                labels: [
                  [
                    { name: "0.1" },
                    { name: "1" },
                    { name: "3" },
                    { name: "4" },
                    { name: "5" },
                    { name: "6" },
                    { name: "7" },
                    { name: "8" },
                    { name: "9" },
                    { name: "10" },
                  ],
                ],
                components: [ka01, ka1, ka3, ka4, ka5, ka6, ka7, ka8, ka9, ka10],
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "ka",
                  scrollbars: false,
                  styles: {
                    fontStyle: "italic",
                    fontWeight: 400,
                    fontSize: "12px",
                    lineHeight: "16px",
                  },
                },
              },
              styles: {
                alignItems: "flex-end",
                textAlign: "start",
                justifyContent: "flex-start",
              },
            },
          },
        ],
      ],
    },
  },
};

export default component;
